/**
 * Show More Form (V2)
 * DOM参照/状態フラグのみを担当
 */

import { FormBase } from "../../../util/form-base-form";

export class ShowMoreForm extends FormBase {
    public root: HTMLElement;

    public toggleButton: HTMLButtonElement | null;

    public labelElement: HTMLElement | null;

    public panelElement: HTMLDivElement | null;

    public contentElement: HTMLDivElement | null;

    public observer: MutationObserver | null;

    public constructor(root: HTMLElement) {
        super();
        this.root = root;
        this.toggleButton = null;
        this.labelElement = null;
        this.panelElement = null;
        this.contentElement = null;
        this.observer = null;
    }

    public static getRoots(scope: Document | HTMLElement = document): HTMLElement[] {
        const form = new ShowMoreForm(scope instanceof HTMLElement ? scope : document.body);
        const roots: HTMLElement[] = [];
        if (scope instanceof HTMLElement && scope.matches("show-more")) {
            roots.push(scope);
        }
        form.getNestedRoots(scope).forEach((root) => {
            if (!roots.includes(root)) {
                roots.push(root);
            }
        });
        return roots;
    }

    public getRoot(): HTMLElement {
        return this.root;
    }

    public getToggle(root: ParentNode = this.root): HTMLButtonElement | null {
        return this.getButton(root, ":scope > .show-more__toggle");
    }

    public getPanel(root: ParentNode = this.root): HTMLDivElement | null {
        return this.queryElement(root, ":scope > .show-more__panel", HTMLDivElement);
    }

    public getContent(root: ParentNode): HTMLDivElement | null {
        return this.queryElement(root, ":scope > .show-more__content", HTMLDivElement);
    }

    public getLabel(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, ".show-more__label", HTMLElement);
    }

    public getClosestToggle(target: EventTarget | Element | null | undefined): HTMLButtonElement | null {
        return this.closest(target, ".show-more__toggle", HTMLButtonElement);
    }

    public getNestedRoots(root: ParentNode): HTMLElement[] {
        return this.queryElements(root, "show-more", HTMLElement);
    }

    public isInitialized(): boolean {
        return this.root.dataset.showMoreInit === "1";
    }

    public markInitialized(): void {
        this.root.dataset.showMoreInit = "1";
    }

    public hasOpenAttribute(): boolean {
        return this.root.hasAttribute("open");
    }

    public setOpenAttribute(open: boolean): void {
        this.root.toggleAttribute("open", !!open);
    }

    public getDurationMs(): number {
        const raw = Number.parseInt(this.root.getAttribute("duration") || "600", 10);
        return Number.isFinite(raw) ? Math.max(0, raw) : 600;
    }

    public getLines(): number {
        const raw = Number.parseInt(this.root.getAttribute("lines") || "0", 10);
        return Number.isFinite(raw) ? Math.max(0, raw) : 0;
    }

    public isClampMode(): boolean {
        return this.getLines() > 0;
    }

    public getLabelText(): string {
        return (this.root.getAttribute("label") || "แสดงเพิ่มเติม").trim() || "แสดงเพิ่มเติม";
    }

    public getOpenLabelText(): string {
        return (this.root.getAttribute("open-label") || "แสดงน้อยลง").trim() || "แสดงน้อยลง";
    }

    public getLabelKey(): string {
        return (this.root.getAttribute("label-key") || "").trim();
    }

    public getOpenLabelKey(): string {
        return (this.root.getAttribute("open-label-key") || "").trim();
    }

    public setObserver(observer: MutationObserver | null): void {
        this.observer = observer;
    }

    public disconnectObserver(): void {
        this.observer?.disconnect();
        this.observer = null;
    }
}
